import React, { useContext } from 'react'
import { IncomingCall } from '~/service/SipConn'
import { UsersManagerContext } from '~/service/UsersManager'
import { formatPhoneNumber } from '~/utils/string'
import CallButton from '../common/CallButton'
import { LanguageIcon } from '../common/LanguageIcon'

type Props = {
  call: IncomingCall
}

const Incoming: React.FC<Props> = ({ call }) => {
  const { get } = useContext(UsersManagerContext)

  const transferingUser =
    call.apiData &&
    call.isIncoming &&
    call.transferedToMeStatus &&
    call.apiData.userId &&
    get(call.apiData.userId)

  return (
    <div className="phone-incoming">
      <div className="phone-incoming-top">
        <figure>
          {call.client && <img src={call.client.avatar} />}

          {transferingUser && <img src={transferingUser.avatar} />}
        </figure>

        {call.client && call.apiData && (
          <h1>
            {call.client.name}
            <LanguageIcon call={call.apiData} />
          </h1>
        )}

        <h2>{formatPhoneNumber(call.number)} </h2>

        {call.apiData && call.apiData.ivr && (
          <div className="phone-incoming-top-ivr">{call.apiData.ivr}</div>
        )}
      </div>

      <div className="phone-incoming-buttons">
        <CallButton onClick={call.answer} />
        <CallButton onClick={call.reject} reject />
      </div>
    </div>
  )
}

export default Incoming
